module.exports = function toNumber(value, standard) {
  if (value) {
    return parseInt(value, 10);
  }

  return standard;
};